import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SelectInput from '@/corePagesModule/SelectInput/SelectInput.vue';
import { useGroupListSelectInputStore } from './useGroupListSelectInputStore';
import { storeToRefs } from 'pinia';
import { computed, onMounted, watch } from 'vue';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupListSelectInput',
  props: {
    selectInputIndex: {},
    storeTag: {},
    selectedGroupIdProp: { default: undefined },
    showLabel: { type: Boolean },
    useReset: { type: Boolean, default: true },
    reload: { type: Boolean },
    useTeleport: { type: Boolean }
  },
  emits: ["selectedGroup", "selectedGroupName"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const t = i18n.t;

const store = useGroupListSelectInputStore(props.storeTag)();
const { state } = storeToRefs(store);

onMounted(() => {
  store.init();
  if (props.selectedGroupIdProp) {
    state.value.selectedGroupId = props.selectedGroupIdProp;
  }
});

watch(
  () => props.selectedGroupIdProp,
  (newVal) => {
    state.value.selectedGroupId = newVal;
  }
);

watch(
  () => props.reload,
  async (newVal) => {
    if (newVal) {
      await store.reloadGroupData();
    }
  }
);

/**
 * グループ名を選択した際の処理
 * @param index - 選択したグループのインデックス
 */
const onSelectedGroup = (index: number) => {
  store.onSelectedGroup(index);
  emits('selectedGroup', state.value.selectedGroupId);
  emits('selectedGroupName', store.selectedGroupName);
};

/**
 * 外すボタンを押した際の処理
 * @param value - 選択したグループ名
 */
const onUpdatedValue = (value: string) => {
  if (value === '') {
    store.onSelectedDefaultValue();
    emits('selectedGroup');
    emits('selectedGroupName');
  }
};

/**
 * セレクトボックスをクリックした際の処理
 */
const onClickSelectInput = async () => {
  await store.reloadGroupData();
  state.value.selectInputState = true;
};

const useLabel = computed(() => (props.showLabel ? t('グループ') : ''));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectInput, {
    index: _ctx.selectInputIndex,
    "model-value": _unref(store).selectedGroupName,
    placeholder: _unref(t)('グループ名'),
    label: useLabel.value,
    "filter-type": 'AGGREGATE_BUSINESS_GROUP',
    "use-reset": _ctx.useReset,
    "is-open-prop": _unref(state).selectInputState,
    "prop-options": _unref(store).groupListNames,
    "prop-paging-state": _unref(state).pagingState,
    "prop-paging-options": _unref(state).pagingOptions,
    "use-teleport": _ctx.useTeleport,
    "onClick:selectInput": _cache[0] || (_cache[0] = () => onClickSelectInput()),
    onClose: _cache[1] || (_cache[1] = () => (_unref(state).selectInputState = false)),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => onUpdatedValue(value)),
    "onUpdate:valueWithIndex": _cache[3] || (_cache[3] = (_, index) => onSelectedGroup(index))
  }, null, 8, ["index", "model-value", "placeholder", "label", "use-reset", "is-open-prop", "prop-options", "prop-paging-state", "prop-paging-options", "use-teleport"]))
}
}

})